import * as R from 'ramda';

export default function DashboardDirectiveController(
  $filter,
  $scope,
  brandColors,
  userService,
  authorizationService,
  orgDataService,
  utilityService
) {
  const vm = this;
  vm.userService = userService;
  vm.authorizationService = authorizationService;

  vm.widgetSize = 500;

  vm.handleToggleWidgetVisibility = _handleToggleWidgetVisibility;
  vm.handleWidgetMoved = _handleWidgetMoved;

  _activate();

  function _activate() {
    _initEventListeners();
    if (authorizationService.getToken()) {
      _refreshDashboard();
    }
  }

  function _refreshDashboard() {
    // _initWidgets().then(() => {
    _initWidgetsData();
    // });
  }

  function _initEventListeners() {
    $scope.$on('loggedIn', _refreshDashboard);
  }

  // function _initWidgets() {
  //   return userService.getWidgets().then((widgets) => {
  //     userService.widgets = $filter('orderBy')(widgets, 'currentSortOrder');
  //     userService.configWidgets = $filter('orderBy')(widgets, 'displayName');
  //     _renderWidgets(false);
  //   });
  // }

  function _initWidgetsData() {
    return orgDataService.getWidgets().then((widgets) => {
      userService.widgets = $filter('orderBy')(widgets.data.result, 'currentSortOrder');
      userService.configWidgets = $filter('orderBy')(widgets.data.result, 'displayName');
    }).then(() => {
      _renderWidgets(true);
    });
  }

  function _renderWidgets(processedUnprocessedWidgets = false) {
    const unprocessedWidgets = [];
    R.forEach(
      (widget) => {
        widget.isVisible = !!((widget.preference === null || widget.preference.visible === true));

        if (widget.result && widget.result.processed === true) {
          _renderWidget(widget);
        } else {
          unprocessedWidgets.push(widget);
        }
      },
      userService.widgets
    );

    if (processedUnprocessedWidgets && unprocessedWidgets.length > 0) {
      _processWidgets(unprocessedWidgets);
    }
  }

  function _renderWidget(widget) {
    if (widget.code === 'SafeSysMailUsers') {
      _renderSSMUsers(widget);
    } else if (widget.type === 'PieGraph') {
      _renderPieCharts(widget);
    } else if (widget.type === 'Calendar') {
      _renderEventCalendar(widget);
    } else if (widget.type === 'DualAxesLineColumn') {
      _renderDualAxesLineColumn(widget);
    } else if (widget.code === 'CAPSUpdateStatus') {
      _renderCAPSUpdateStatusGraph(widget);
    } else if (widget.code === 'PatchesInstalled') {
      _renderPatchesInstalled(widget);
    } else if (widget.code === 'CVaultDataGrowthTrend') {
      _renderCVaultDataGrowthTrend(widget);
    } else if (widget.code === 'ContinuumDataGrowthTrend') {
      _renderContinuumDataGrowthTrend(widget);
    } else if (widget.code === 'EncryptedMessages') {
      _renderEncryptedMessages(widget);
    }
  }

  function _processWidgets(unprocessedWidgets) {
    R.forEach(
      (unprocessedWidget) => {
        const existingWidget = R.find(
          R.propEq(
            'widgetId',
            unprocessedWidget.widgetId
          ),
          userService.widgets
        );

        orgDataService.getWidget(
          unprocessedWidget.widgetId
        ).then((getWidgetResponse) => {
          existingWidget.result = getWidgetResponse.data.result;
          _renderWidget(existingWidget);
        });
      },
      unprocessedWidgets
    );
  }

  function _handleToggleWidgetVisibility(widget) {
    widget.isVisible = !widget.isVisible;

    _saveWidgetUserPreferences();
  }

  function _handleWidgetMoved($index) {
    userService.widgets.splice($index, 1);

    const forEachWithIndex = R.addIndex(R.forEach);

    forEachWithIndex(
      (widget, currIndex) => {
        widget.currentSortOrder = currIndex + 1;
        if (widget.preference) {
          widget.preference.sortOrder = currIndex + 1;
        }
      },
      userService.widgets
    );

    _saveWidgetUserPreferences();
  }

  function _saveWidgetUserPreferences() {
    return userService.getUser().then((user) => {
      const widgetUserPreferences = [];
      R.forEach(
        (currentWidget) => {
          const widgetUserPreference = {
            widgetId: currentWidget.widgetId,
            userId: user.userId,
            sortOrder: currentWidget.currentSortOrder,
            visible: currentWidget.isVisible,
          };
          widgetUserPreferences.push(widgetUserPreference);
        },
        userService.widgets
      );
      orgDataService.saveBulkWidgetPreferences(
        widgetUserPreferences
      );
    });
  }

  function _renderSSMUsers(widget) {
    const series = [];
    const chartData = widget.result.data.table;
    R.forEach(
      (item) => {
        series.push({
          name: 'Email Users',
          y: item.unitsUsed,
        });
        series.push({
          name: 'Remaining User Licenses',
          y: item.unitsFree,
        });
      },
      chartData
    );

    const options = {
      chart: {
        type: 'pie',
        width: vm.widgetSize,
        height: vm.widgetSize,
      },
      title: null,
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter() {
          return (`<b>${this.point.name}</b>: ${this.y}`);
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: { enabled: false },
          showInLegend: true
        }
      },
      series: [
        {
          type: 'pie',
          name: 'Browser share',
          data: series
        }
      ]
    };

    widget.chartOptions = options;
  }

  function _renderPieCharts(widget) {
    const series = [];
    R.forEach(
      (dataItem) => {
        const seriesDataItem = {};
        if (dataItem.color === 'red') {
          seriesDataItem.color = brandColors.bankersLoveRed.$75;
        } else if (dataItem.color === 'yellow') {
          seriesDataItem.color = brandColors.navantaCoral.$75;
        } else if (dataItem.color === 'green') {
          seriesDataItem.color = brandColors.hulaSkirtGreen.$75;
        } else if (dataItem.color === 'blue' || dataItem.color === '#251759') {
          seriesDataItem.color = brandColors.navantaDeepPurple.$55;
        }
        seriesDataItem.y = dataItem.amount;
        seriesDataItem.name = dataItem.label;
        series.push(seriesDataItem);
      },
      widget.result.data.table
    );
    const options = {
      chart: {
        type: 'pie',
        width: vm.widgetSize,
        height: vm.widgetSize,
      },
      credits: {
        enabled: false,
      },
      title: null,
      tooltip: {
        headerFormat: null,
        pointFormat: '{point.name}: <b>{point.y}</b>'
      },
      plotOptions: {
        pie: {
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        }
      },

      series: [{
        data: series
      }],
    };
    widget.chartOptions = options;
  }

  function _renderCAPSUpdateStatusGraph(widget) {
    const products = [];
    const upToDate = [];
    const outOfDateNotEx = [];
    const outOfDateEx = [];
    R.forEach(
      (item) => {
        products.push(item.product);
        upToDate.push(item.upToDate);
        outOfDateNotEx.push(item.outOfdateNotEx);
        outOfDateEx.push(item.outOfDateEx);
      },
      widget.result.data.table
    );
    const options = {
      chart: {
        type: 'bar',
        width: vm.widgetSize,
        height: vm.widgetSize
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: products,
        title: {
          enabled: null,
        },
      },
      plotOptions: {
        series: {
          stacking: 'percent'
        }
      },
      title: null,
      series: [
        {
          name: 'Up to Date',
          data: upToDate,
          color: brandColors.hulaSkirtGreen.$75,
        },
        {
          name: 'Out of Date (Excluded)',
          data: outOfDateEx,
          color: brandColors.navantaCoral.$75,
        },
        {
          name: 'Out of Date (Not Excluded)',
          data: outOfDateNotEx,
          color: brandColors.bankersLoveRed.$75,
        }
      ],
    };
    widget.chartOptions = options;
  }

  function _renderPatchesInstalled(widget) {
    const series = [];
    const categories = [];
    R.forEach(
      (item) => {
        series.push(item.bankPctInstalled);
        const splitDateStringArray = Date(
          parseInt(
            item.full_date.substr(
              6,
              item.full_date.length - 8
            ), 10
          )
        ).toString().split(' ');
        const month = splitDateStringArray[1];
        const monthNumber = utilityService.getMonthNumberByAbbreviatedName(month);
        const finalDateString = `${monthNumber}/${splitDateStringArray[2]}/${splitDateStringArray[3]}`;
        categories.push(finalDateString);
      },
      widget.result.data.table
    );

    const decMin = Math.min(...series);
    let minYAxis = 90;
    if (decMin < 50) {
      minYAxis = 40;
    } else if (decMin < 60) {
      minYAxis = 50;
    } else if (decMin < 70) {
      minYAxis = 60;
    } else if (decMin < 80) {
      minYAxis = 70;
    } else if (decMin < 90) {
      minYAxis = 80;
    }
    const options = {
      chart: {
        defaultSeriesType: 'line',
        width: vm.widgetSize,
        height: vm.widgetSize,
      },
      title: null,
      credits: {
        enabled: false,
      },
      xAxis: {
        categories,
        labels: {
          rotation: -45,
          align: 'right'
        }
      },
      yAxis: {
        title: {
          text: 'Pct Installed'
        },
        max: 100,
        min: minYAxis
      },
      series: [
        {
          name: 'Customer',
          data: series
        }
      ]
    };
    widget.chartOptions = options;
  }

  function _renderEventCalendar(widget) {
    const events = R.map(
      (event) => {
        let color;
        let textColor;
        if (event.color === 'green') {
          color = brandColors.hulaSkirtGreen.$75;
          textColor = brandColors.hulaSkirtGreen.$5;
        } else if (event.color === 'yellow') {
          color = brandColors.navantaCoral.$75;
          textColor = brandColors.navantaCoral.$5;
        } else if (event.color === 'red') {
          color = brandColors.bankersLoveRed.$75;
          textColor = brandColors.bankersLoveRed.$5;
        }
        return {
          title: event.description,
          color,
          textColor,
          start: new Date(event.full_date),
          allDay: true,
        };
      },
      widget.result.data.table
    );

    widget.calendarOptions = {
      height: vm.widgetSize,
      events,
    };
  }

  function _renderDualAxesLineColumn(widget) {
    const seriesPerMonth = [];
    const seriesYTD = [];
    const categories = [];
    let maxHours = null;
    let totalHours = 0;

    R.forEach(
      (item) => {
        if (maxHours < item.maxSupportHours) {
          maxHours = item.maxSupportHours;
        }
        totalHours += item.hoursToBill;

        seriesPerMonth.push(item.hoursToBill);
        seriesYTD.push(totalHours);
        categories.push(item.monthName);
      },
      R.sort(d => d.yyymm, widget.result.data.table)
    );

    const options = {
      chart: {
        zoomType: 'xy',
        options3d: {
          enabled: true
        },
        width: vm.widgetSize,
        height: vm.widgetSize,
      },
      title: {
        text: null
      },
      credits: {
        enabled: false,
      },
      xAxis: [{
        categories,
        crosshair: true
      }],
      yAxis: [{ // Primary yAxis
        max: maxHours + 20,
        labels: {
          format: '{value} hrs',
        },
        plotLines: [{
          value: maxHours,
          color: 'red',
          dashStyle: 'shortdash',
          width: 2,
          label: {
            text: `${maxHours} Max Hours`
          }
        }],
        title: {
          text: 'Hours Used',
        }
      }, { // Secondary yAxis
        max: maxHours + 20,
        visible: false,
        title: {
          text: null,
        },
        opposite: true
      }],
      tooltip: {
        shared: true
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        // x: 120,
        // y: 30,
        floating: true,
      },
      series: [
        {
          name: 'Hours',
          type: 'column',
          yAxis: 1,
          data: seriesPerMonth,
          tooltip: {
            valueSuffix: '{value} hrs'
          }
        }, {
          name: 'Hours YTD',
          type: 'spline',
          color: 'orange',
          data: seriesYTD,
          tooltip: {
            valueSuffix: '{value} hrs'
          }
        }
      ]
    };

    widget.chartOptions = options;
  }

  function _renderCVaultDataGrowthTrend(widget) {
    const highChartData = widget.result.data.table;
    const series = [];
    const categories = [];
    R.forEach(
      (item) => {
        const formattedDate = new Date(item.full_date);
        const backUpData = JSON.parse(item.backupSizeQuota);
        series.push({
          x: formattedDate,
          y: backUpData
        });
        const backUpData2 = JSON.parse(Math.round(item.totalBackupSetActualSize * 100) / 100);
        categories.push({
          x: formattedDate,
          y: backUpData2
        });
      },
      highChartData
    );

    const options = {
      chart: {
        defaultSeriesType: 'spline',
        zoomType: 'x',
        width: vm.widgetSize,
        height: vm.widgetSize,
      },
      title: null,
      credits: {
        enabled: false,
      },
      xAxis: {

        type: 'datetime',
        showLastLabel: true,
        maxPadding: 0.1,
        dateTimeLabelFormats: { // don't display the dummy year
          month: '%b %e',
          year: ''
        }

      },
      yAxis: {
        title: {
          text: 'Data Size (GB)'
        },
        min: 0
      },
      plotOptions: {
        spline: {
          lineWidth: 4,
          states: {
            hover: {
              lineWidth: 5
            }
          },
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: true,
                symbol: 'circle',
                radius: 5,
                lineWidth: 1
              }
            }
          }
        }
      },
      series: [
        {
          name: 'Backup Actual',
          data: categories

        },
        {
          name: 'Backup Quota',
          data: series
        }
      ]
    };

    widget.chartOptions = options;
  }

  function _renderContinuumDataGrowthTrend(widget) {
    const highChartData = widget.result.data.table;
    const series = [];
    const categories = [];
    R.forEach(
      (item) => {
        const formattedDate = new Date(item.full_date);
        const backUpData = JSON.parse(item.backupSizeQuota);
        series.push({
          x: formattedDate,
          y: backUpData
        });
        const backUpData2 = JSON.parse(Math.round(item.totalBackupSetActualSize * 100) / 100);
        categories.push({
          x: formattedDate,
          y: backUpData2
        });
      },
      highChartData
    );

    const options = {
      chart: {
        defaultSeriesType: 'spline',
        zoomType: 'x',
        width: vm.widgetSize,
        height: vm.widgetSize,
      },
      title: null,
      credits: {
        enabled: false,
      },
      xAxis: {

        type: 'datetime',
        showLastLabel: true,
        maxPadding: 0.1,
        dateTimeLabelFormats: { // don't display the dummy year
          month: '%b %e',
          year: ''
        }

      },
      yAxis: {
        title: {
          text: 'Data Size (GB)'
        },
        min: 0
      },
      plotOptions: {
        spline: {
          lineWidth: 4,
          states: {
            hover: {
              lineWidth: 5
            }
          },
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: true,
                symbol: 'circle',
                radius: 5,
                lineWidth: 1
              }
            }
          }
        }
      },
      series: [
        {
          name: 'Backup Actual',
          data: categories

        },
        {
          name: 'Backup Quota',
          data: series
        }
      ]
    };

    widget.chartOptions = options;
  }

  function _renderEncryptedMessages(widget) {
    const periods = [];
    const outboundEmails = [];
    const inboundEmails = [];
    const forEachWithIndex = R.addIndex(R.forEach);
    forEachWithIndex(
      (item, index) => {
        if (index <= 6) {
          periods.push(item.period);
          outboundEmails.push(item.outboundemails);
          inboundEmails.push(item.inboundemails);
        }
      },
      widget.result.data.table
    );

    const options = {
      chart: {
        defaultSeriesType: 'column',
        width: vm.widgetSize,
        height: vm.widgetSize,
      },
      title: null,
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: periods
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color: brandColors.justNavy.$75,
          }
        }
      },
      tooltip: {
        formatter() {
          return `<b>${this.x}</b><br/>${this.series.name}: ${this.y}<br/>Total: ${this.point.stackTotal}`;
        }
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            color: brandColors.navantaDeepPurple.$75,
          }
        }
      },
      series: [
        {
          name: 'Outbound Emails',
          data: outboundEmails
        },
        {
          name: 'Inbound Emails',
          data: inboundEmails
        }
      ]
    };

    widget.chartOptions = options;
  }
}

DashboardDirectiveController.$inject = [
  '$filter',
  '$scope',

  'brandColors',
  'userService',
  'authorizationService',
  'orgDataService',
  'utilityService',
];
